// @flow
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React from 'react';

import Input from '../Input';
import styles from './userContactsForm.css';
import InputError from '../InputError';

type TextProps = {
  value: boolean,
  onChange: Function,
  placeholder?: string,
  canEdit?: boolean,
  isEditing?: boolean,
  onDoubleClick?: any,
  error: string,
  onEnter?: any,
  highlight?: boolean,
};

const Text = ({
  canEdit,
  isEditing,
  placeholder = '',
  value,
  error,
  onChange,
  onDoubleClick,
  onEnter,
  highlight,
}: TextProps) => {
  return (
    <div
      onDoubleClick={() => {
        if (canEdit) onDoubleClick();
      }}
      className={`${styles.textContainer} ${highlight ? styles.highlight : ''}`}
    >
      {!canEdit ? (
        <p>{value}</p>
      ) : isEditing ? (
        <div
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              onEnter();
            }
          }}
        >
          {error && <InputError title={error} className={styles.error} />}
          <Input
            value={`${value}`}
            placeholder={placeholder}
            onChange={(event) => {
              if (onChange) onChange(event.target.value);
            }}
          />
        </div>
      ) : (
        <p>{value}</p>
      )}
    </div>
  );
};

export default Text;



// WEBPACK FOOTER //
// ./src/scripts/components/UserContactsForm/text.jsx